import React, { useEffect, useState } from 'react';
import style from './login-signup.module.scss';
import SignUpModal from '../SignUpModal/SignUpModal';
import LoginModal from '../LoginModal/LoginModal';
import { useRouter } from 'next/navigation';

type Props = {
  onClose: () => void;
};

const LoginSignup = ({ onClose }: Props) => {
  const [activeTab, setActiveTab] = useState('login');
  const router = useRouter();
  const hash = localStorage.getItem('mode') || 'login';
  useEffect(() => {
    if (hash === 'sign up') {
      setActiveTab('signup');
      setTimeout(() => {
        localStorage.removeItem('mode');
      }, 1000);
    } else {
      setActiveTab('login');
    }
  }, []);

  return (
    <div className={style['login-modal__container']}>
      <div className={style['login-modal__tabs']}>
        <div
          className={`${style['login-modal__tab']} ${
            activeTab === 'login' ? style['login-modal__active-tab'] : ''
          }`}
          onClick={() => {
            setActiveTab('login');
          }}
        >
          LOG IN
        </div>
        <div
          className={`${style['login-modal__tab']} ${
            activeTab === 'signup' ? style['login-modal__active-tab'] : ''
          }`}
          onClick={() => {
            setActiveTab('signup');
          }}
        >
          SIGN UP
        </div>
      </div>
      <div className={style['login-modal__tabs_content']}>
        <div>
          <div style={{ display: activeTab === 'login' ? 'block' : 'none' }}>
            <LoginModal onClose={onClose} />
          </div>
          <div style={{ display: activeTab != 'login' ? 'block' : 'none' }}>
            <SignUpModal onClose={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginSignup;
